// Add expense, receipt first — the reader's state, without the DOM (build pack
// 26/10/2026, pages 16–17). The form calls attach() when a receipt is dropped
// or photographed; there is no Read button (Karan 26/10: button-free).
//
//   empty    the form is usable; a note says drop the receipt first
//   reading  fields locked, Save waits; "Fill it in yourself" unlocks at once
//   read     the answer is in the form, tagged From the receipt (or Check)
//   failed   the reader failed or took over 15 s: fields unlock, the receipt
//            stays attached — "Couldn't read this receipt. Fill it in below;
//            it's still attached."
//   manual   filled in by hand (Fill it in yourself, No receipt, or the
//            reader is switched off)
//
// The reader never saves. Whatever state it ends in, a person checks the form
// and presses Add expense. A late answer — after the timeout or after "Fill it
// in yourself" — is dropped: it never lands on top of what someone typed.
export const READ_LIMIT_MS = 15000;

export function createReceiptReader({ read, enabled = true, limitMs = READ_LIMIT_MS, setTimer = setTimeout, clearTimer = clearTimeout, onChange = () => {} } = {}) {
  const s = { phase: 'empty', file: null, result: null, error: '', noReceipt: false, reqId: 0, timer: null };
  const emit = () => onChange(view());
  const stop = () => { if (s.timer != null) { clearTimer(s.timer); s.timer = null; } };

  function view() {
    return {
      phase: s.phase, file: s.file, result: s.result, error: s.error, noReceipt: s.noReceipt,
      locked: s.phase === 'reading',
    };
  }

  return {
    view,
    /** A receipt dropped, chosen or photographed. `file` is whatever the caller reads later (kept attached). */
    attach(file) {
      stop();
      s.file = file; s.noReceipt = false; s.result = null; s.error = '';
      const id = (s.reqId += 1);
      if (!enabled) { s.phase = 'manual'; emit(); return; }
      s.phase = 'reading';
      s.timer = setTimer(() => {
        if (id !== s.reqId || s.phase !== 'reading') return;
        s.timer = null; s.reqId += 1;
        s.phase = 'failed'; s.error = 'timeout';
        emit();
      }, limitMs);
      emit();
      Promise.resolve().then(() => read(file)).then((r) => {
        if (id !== s.reqId || s.phase !== 'reading') return;
        stop();
        s.result = r; s.phase = 'read';
        emit();
      }, (e) => {
        if (id !== s.reqId || s.phase !== 'reading') return;
        stop();
        s.phase = 'failed'; s.error = (e && e.message) || 'failed';
        emit();
      });
    },
    /** "Fill it in yourself": unlocks at once; the receipt stays attached. */
    fillYourself() {
      if (s.phase !== 'reading') return;
      stop(); s.reqId += 1; s.phase = 'manual';
      emit();
    },
    /** "No receipt": the claim goes to the approver marked so. */
    noReceipt() { stop(); s.reqId += 1; s.file = null; s.result = null; s.noReceipt = true; s.phase = 'manual'; emit(); },
    /** Take the receipt off (Replace starts again with attach()). */
    clear() { stop(); s.reqId += 1; s.file = null; s.result = null; s.noReceipt = false; s.phase = 'empty'; emit(); },
    dispose() { stop(); s.reqId += 1; },
  };
}
